import clsx from 'clsx';
import { Base } from '@gandi/ui';
import ErrorIcon from './Svg/error';
import FailIcon from './Svg/fail';
import OkIcon from './Svg/ok';
import WarningIcon from './Svg/warning';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "round": "StatusIcon-round_1Khy4",
  "ok": "StatusIcon-ok_2Aia8",
  "warning": "StatusIcon-warning_27538",
  "fail": "StatusIcon-fail_3w5e9",
  "mobile": "StatusIcon-mobile_NiEPS",
  "desktop": "StatusIcon-desktop_K-GJ3",
  "svg": "StatusIcon-svg_gV3vL"
};
const svgComponent = {
  ok: OkIcon,
  warning: WarningIcon,
  fail: FailIcon,
  error: ErrorIcon
};
export function StatusIcon({
  iconName,
  className
}) {
  const Svg = svgComponent[iconName];
  return /*#__PURE__*/_jsx(Base, {
    flex: true,
    flexShrink0: true,
    flexAlignItemsCenter: true,
    flexJustifyCenter: true,
    className: clsx(className, styles.desktop, styles[iconName], styles.round),
    children: /*#__PURE__*/_jsx(Svg, {
      "aria-hidden": "true",
      className: styles.svg
    })
  });
}